export const actionTypes = {
  REQUEST_START: 'TAPS.INCOME.TYPES.REQUEST_START',
  REQUEST_SUCCESS: 'TAPS.INCOME.TYPES.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'TAPS.INCOME.TYPES.REQUEST_FAILURE',
};

export function startRequest(year) {
  return {
    type: actionTypes.REQUEST_START,
    year,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}
